import { analyticsActions } from './analytics/analytics';

export const actions = {
  analytics: analyticsActions
};

export default actions;